export var data = {
    "blogs" : [
        {
            "id": 1,
            "title": "Vaccination Slot Finder",
            "body": "It will help trigger notification if vaccination is available at any center at any given district.",
            "imageUrl": "/images/blog/vaccination.png",
            "github": "https://github.com/SunandanBose/Vaccination-Slot-Finder"
        },
        {
            "id": 2,
            "title": "Data Structure and Algorithm",
            "body": "Solve Data Structure problems in managing and storing data in efficient format that enables efficient access and modification.",
            "imageUrl": "/images/blog/DataStructure.png",
            "github": "https://github.com/SunandanBose/practiceDS"
        },
        {
            "id": 3,
            "title": "Notification Service",
            "body": "Send mail and message notification service for any given template.",
            "imageUrl": "/images/blog/Notification.jpeg",
            "github": "https://github.com/SunandanBose/Notification"
        },
        {
            "id": 4,
            "title": "UnIdiot Blogging Website",
            "body": "Blogging Website where you can write blogs",
            "imageUrl": "/images/blog/event_mgmt.png",
            "github": "https://github.com/SunandanBose/event-mgmt"
        }
    ]
}